export default "__VITE_ASSET__BR1M4DHU__"